var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-input"},[_c('label',{},[_vm._v(_vm._s(_vm.label))]),_c('v-text-field',_vm._g(_vm._b({staticClass:"input",attrs:{"label":_vm.placeholder,"outlined":"","solo":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }